package org.example.project.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.model.User

@Composable
fun SettingsOverlay(
    user: User,
    onClose: () -> Unit,
    onLogout: () -> Unit,
    volume: Float,
    soundEnabled: Boolean,
    animationsEnabled: Boolean,
    showCoordinates: Boolean,
    onSoundChanged: (Boolean) -> Unit,
    onAnimationsChanged: (Boolean) -> Unit,
    onCoordinatesChanged: (Boolean) -> Unit,
    onVolumeChanged: (Float) -> Unit

) {



    BoxWithConstraints(
        modifier = Modifier
            .fillMaxSize()
            .background(
                Color.Black.copy(alpha = 0.65f)
            ),
        contentAlignment = Alignment.Center
    ) {

        val isMobile = maxWidth < 700.dp

        val cardWidth =
            if (isMobile)
                maxWidth * 0.95f
            else
                750.dp

        val titleSize =
            if (isMobile)
                28.sp
            else
                36.sp

        val scrollState = rememberScrollState()

        Card(
            modifier = Modifier
                .width(cardWidth)
                .fillMaxHeight(
                    if (isMobile) 0.9f else 0.85f
                ),
            shape = RoundedCornerShape(24.dp),

            border = BorderStroke(
                2.dp,
                Color(0xFF00E5FF)
            ),

            colors = CardDefaults.cardColors(
                containerColor =
                    Color(0xCC001B33)
            )
        ) {

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(scrollState)
                    .padding(
                        if (isMobile) 16.dp else 24.dp
                    )
            ) {

                Text(
                    text = "SETTINGS",
                    color = Color.White,
                    fontSize = titleSize,
                    fontWeight = FontWeight.Bold
                )

                Text(
                    text = "Configure Your Command Center",
                    color = Color(0xFF00E5FF),
                    fontSize =
                        if (isMobile)
                            16.sp
                        else
                            18.sp
                )

                Spacer(
                    modifier = Modifier.height(24.dp)
                )

                SectionTitle(
                    "PROFILE"
                )

                InfoRow(
                    "Commander",
                    user.username,
                    isMobile
                )

                InfoRow(
                    "Email",
                    user.email,
                    isMobile
                )

                Spacer(
                    modifier = Modifier.height(24.dp)
                )

                SectionTitle(
                    "STATISTICS"
                )

                InfoRow(
                    "Wins",
                    user.wins.toString()
                )

                InfoRow(
                    "Losses",
                    user.losses.toString()
                )

                InfoRow(
                    "Games Played",
                    user.gamesPlayed.toString()
                )

                InfoRow(
                    "Score",
                    user.score.toString()
                )

                Spacer(
                    modifier = Modifier.height(24.dp)
                )

                SectionTitle(
                    "PREFERENCES"
                )

                SettingToggle(
                    title = "Sound Effects",
                    checked = soundEnabled,
                    onCheckedChange = onSoundChanged,
                    isMobile = isMobile
                )
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(vertical = 8.dp)
                ) {

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {

                        Text(
                            "Master Volume",
                            color = Color.White,
                            fontWeight = FontWeight.SemiBold
                        )

                        Text(
                            "${(volume * 100).toInt()}%",
                            color = Color(0xFF00E5FF),
                            fontWeight = FontWeight.Bold
                        )
                    }

                    Spacer(Modifier.height(8.dp))

                    Slider(
                        value = volume,
                        onValueChange = onVolumeChanged,
                        enabled = soundEnabled,
                        colors = SliderDefaults.colors(

                            thumbColor = Color(0xFF00E5FF),

                            activeTrackColor = Color(0xFF00E5FF),

                            inactiveTrackColor = Color(0x3300E5FF),

                            activeTickColor = Color.Transparent,
                            inactiveTickColor = Color.Transparent
                        )
                    )
                }

                HorizontalDivider()
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(20.dp),

                    horizontalArrangement =
                        if (isMobile)
                            Arrangement.Center
                        else
                            Arrangement.End
                ) {

                    OutlinedButton(
                        onClick = onClose,
                        border =
                            BorderStroke(
                                2.dp,
                                Color(0xFF00E5FF)
                            )
                    ) {

                        Text(
                            "CLOSE",
                            color = Color(0xFF00E5FF)
                        )
                    }

                    Spacer(
                        Modifier.width(12.dp)
                    )

                    Button(
                        onClick = onLogout,
                        colors =
                            ButtonDefaults.buttonColors(
                                containerColor = Color.Red
                            )
                    ) {

                        Text(
                            "LOGOUT",
                            color = Color.White
                        )
                    }
                }
            }
        }
    }
}


@Composable
private fun SectionTitle(
    title: String
) {

    Text(
        text = title,
        color = Color(0xFF00E5FF),
        fontWeight = FontWeight.Bold,
        fontSize = 18.sp
    )

    Spacer(
        modifier = Modifier.height(8.dp)
    )
}

@Composable
private fun InfoRow(
    label: String,
    value: String,
    isMobile: Boolean = false
) {

    if (isMobile) {

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 6.dp)
        ) {

            Text(
                text = label,
                color = Color.LightGray
            )

            Text(
                text = value,
                color = Color.White,
                fontWeight = FontWeight.SemiBold
            )
        }

    } else {

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 4.dp),
            horizontalArrangement =
                Arrangement.SpaceBetween
        ) {

            Text(
                text = label,
                color = Color.LightGray
            )

            Text(
                text = value,
                color = Color.White,
                fontWeight = FontWeight.SemiBold
            )
        }
    }
}
@Composable
private fun InfoRow(
    label: String,
    value: String
) {

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp),

        horizontalArrangement =
            Arrangement.SpaceBetween
    ) {

        Text(
            text = label,
            color = Color.LightGray
        )

        Text(
            text = value,
            color = Color.White,
            fontWeight = FontWeight.SemiBold
        )
    }
}

@Composable
private fun SettingToggle(
    title: String,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    isMobile: Boolean
) {

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                vertical =
                    if (isMobile)
                        8.dp
                    else
                        5.dp
            ),

        horizontalArrangement =
            Arrangement.SpaceBetween,

        verticalAlignment =
            Alignment.CenterVertically
    ) {

        Text(
            text = title,
            color = Color.White
        )

        Switch(
            checked = checked,
            onCheckedChange =
                onCheckedChange,

            colors =
                SwitchDefaults.colors(
                    checkedThumbColor =
                        Color(0xFF00E5FF),

                    checkedTrackColor =
                        Color(0x5500E5FF)
                )
        )
    }
}